export const Default = {
    methods: {
        disableAutocomplete: function() {
            if (!this.$el || !this.$el.querySelectorAll)
                return;

            this.$el.querySelectorAll('[autocomplete="off"]').forEach((element) => {
                if (element.autocomplete === 'off') {
                    element.autocomplete = 'disabled';
                    element.readOnly = true;
                    element.addEventListener('focus', (e) => {
                        e.target.readOnly = false;
                    });
                }
            });
        }
    },
    mounted() {
        this.disableAutocomplete();
    }
};
